import React,{useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSettingsField } from "../../store/slices/settings";
import Loader from '../../common/Loader';

const EInvoicing = ({ data }) => {
  const dispatch = useDispatch();
  const setting = useSelector((state) => state?.settings?.updatesettings);

   const [isLoading, setIsLoading] = useState(false);
     const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
        setIsLoading(true);
       }

  return (
    <>
         {isLoading && <Loader />}
      <div id="taxes" role="tabpanel" aria-labelledby="taxes-tab">
        <div className="container">
          <div className="row pt-4">
            <div className="col-6 pt-1">
              <div className="form-group row my-2">
                <label className="col-sm-4 col-form-label">Validate GST Number</label>
                <div className="col-sm-8">
                  <div className="input-group">
                    <input name="gst_number" type="text" className="form-control" />
                    {errors.gst_number && <span className="text-danger">{errors.gst_number}</span>}
                    <div className="input-group-append">
                      <button type="button" className="btn btn-default" onClick={handleSubmit} disabled={isLoading}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-4 col-form-label">IRIS Client ID</label>
                <div className="col-sm-8">
                  <input name="iris_client_id" type="text" className="form-control form-control-sm"    value={
                                      setting?.iris_client_id ??
                                      data?.iris_client_id
                                    }
                                    onChange={(e) => {
                                      dispatch(
                                        updateSettingsField({
                                          iris_client_id: e.target.value,
                                        })
                                      );
                                    }} />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-4 col-form-label">IRIS Client Secret</label>
                <div className="col-sm-8">
                  <input name="iris_client_secret" type="text" className="form-control form-control-sm"  value={
                                      setting?.iris_client_secret ??
                                      data?.iris_client_secret
                                    }
                                    onChange={(e) => {
                                      dispatch(
                                        updateSettingsField({
                                          iris_client_secret: e.target.value,
                                        })
                                      );
                                    }}  />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-4 col-form-label">IRIS Username</label>
                <div className="col-sm-8">
                  <input name="iris_user_id" type="text" className="form-control form-control-sm" value={
                                      setting?.iris_user_id ??
                                      data?.iris_user_id
                                    }
                                    onChange={(e) => {
                                      dispatch(
                                        updateSettingsField({
                                          iris_user_id: e.target.value,
                                        })
                                      );
                                    }}  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EInvoicing;
